
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33919',
  depVersions: {
  "documents-public-ui": "static-1.33919",
  "client-types": "static-1.444",
  "documents-lib": "static-1.33924",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1903",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.99",
  "hs-promise-utils": "static-1.5369",
  "hs-test-utils": "static-1.7783",
  "hub-http": "static-1.5966",
  "hubspot-dlb": "static-2.1796",
  "HubStyleTokens": "static-2.11201",
  "I18n": "static-7.1562",
  "jasmine-immutable": "static-1.2796",
  "jasmine-runner": "static-1.6250",
  "lodash": "static-1.3",
  "quartz": "static-1.6694",
  "react": "static-7.177",
  "react-dlb": "static-1.71",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16419",
  "reporting-data": "static-1.66430",
  "reporting-testing-lib": "static-1.8363",
  "reporting-visualizations": "static-1.58506",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4543",
  "webpack-env": "static-1.54",
  "atom": "static-1.4848",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2263",
  "classnames": "static-2.10",
  "cssUtils": "static-1.725",
  "customer-data-filters-ui": "static-1.38822",
  "customer-data-objects": "static-1.7422",
  "customer-data-property-utils": "static-1.7849",
  "data-fetching-client": "static-1.9456",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4307",
  "flux-actions": "static-1.304",
  "FormsCommonComponents": "static-1.85244",
  "FormUrlGenerator": "static-2.4508",
  "foundations-components": "static-1.7483",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3917",
  "HubStyle": "static-2.11509",
  "icons": "static-2.618",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6940",
  "metrics-js": "static-1.9391",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3637",
  "property-translator": "static-1.5191",
  "quartz-config": "static-1.472",
  "quartz-core": "static-1.5913",
  "quick-fetch": "static-1.3713",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5153",
  "react-virtualized": "static-2.94",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7938",
  "reference-resolvers-lite": "static-1.7868",
  "report-customization-components": "static-1.12447",
  "reporting-enablement": "static-1.22007",
  "reporting-reports": "static-1.66108",
  "reporting-snowflake": "static-1.55048",
  "reporting-ui-components": "static-2.63701",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4410",
  "sales-content-partitioning": "static-1.8713",
  "SalesContentIndexUI": "static-3.8867",
  "sanitize": "static-1.4252",
  "sanitize-text": "static-1.7918",
  "self-service-api": "static-1.10014",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1532",
  "signup-constants": "static-1.18342",
  "signup-ui-lego-core": "static-1.20352",
  "signup-ui-url-generator": "static-2.7843",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.483",
  "superstore": "static-1.4549",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10772",
  "ui-addon-i18n": "static-1.10910",
  "ui-addon-react-router-dom": "static-1.9326",
  "ui-addon-upgrades": "static-9.17618",
  "ui-asset-management-lib": "static-1.10678",
  "ui-images": "static-2.1085",
  "UIComponents": "static-3.8148",
  "usage-tracker": "static-1.7110",
  "usage-tracker-container": "static-1.7100",
  "usage-tracker-core": "static-1.6960",
  "usage-tracker-public": "static-1.6921",
  "viral-links-lib": "static-1.6808",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3208",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2971",
  "quartz-webpack": "static-1.2918",
  "ai-components-ui-library": "static-1.8294",
  "amplitude-session-replay-browser": "static-1.55",
  "foundations-assets": "static-1.4611",
  "foundations-theming": "static-1.4187",
  "quartz-auth": "static-1.369",
  "usage-tracker-session-replay": "static-1.4796",
  "foundations-theming-base": "static-1.3172",
  "HeadJS": "static-2.704",
  "framer-motion": "static-1.67",
  "hs-test-utils-bend-plugin": "static-1.2894",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4107",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7702",
  "graphql": "static-1.77",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3485",
  "reporting-client-types": "static-1.2382",
  "foundations-components-legacy": "static-1.508",
  "hs-story-utils": "static-1.9206",
  "react-flip-move": "static-1.65",
  "hub-http-shared-msw-handlers": "static-1.9429",
  "hubspotter-http": "static-1.4457",
  "sassPrefix": "static-1.151",
  "conversations-skeleton-state": "static-1.7027",
  "crm-message-bus": "static-1.42295",
  "customer-data-filters-ui-msw-helpers": "static-1.21256",
  "customer-data-objects-ui-components": "static-1.12782",
  "customer-data-reference-ui-components": "static-1.12919",
  "customer-data-ui-utilities": "static-1.9601",
  "framework-builder-read-service-client": "static-1.3817",
  "framework-data-schema-quick-fetch": "static-1.6553",
  "framework-data-schema-resolvers": "static-1.6648",
  "inbound-db-properties-service-client": "static-1.3655",
  "multi-account-reference-resolvers": "static-1.748",
  "onboarding-tours": "static-1.16225",
  "reporting-datasets-permissions-lib": "static-1.12980",
  "ui-addon-teams": "static-1.21209",
  "apollo-stack-hubspot": "static-3.81",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67562",
  "customer-data-properties": "static-1.50743",
  "forms-ai-lib": "static-1.3979",
  "forms-utils-lib": "static-1.12127",
  "foundations-components-test-utils": "static-1.4966",
  "react-dnd-compat": "static-1.4400",
  "react-tinymce": "static-1.54563",
  "tinymce-config": "static-2.53689",
  "ui-gdpr-components": "static-1.10125",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3752",
  "floating-ui": "static-1.51",
  "react-aria": "static-1.61",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1127",
  "ui-fonts": "static-1.463",
  "dispatcher": "static-1.131",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.787",
  "mobile-manifest-mixins": "static-1.477",
  "module-federation": "static-1.18",
  "quartz-head": "static-1.359",
  "quartz-i18n": "static-1.369",
  "quartz-routing": "static-1.124",
  "quartz-test": "static-1.369",
  "batch-promise": "static-1.1328",
  "external-options-client-types": "static-1.3964",
  "react-colorpicker": "static-2.9989",
  "copilot-toolkit": "static-1.10468",
  "data-quality-ui-library": "static-1.12271",
  "html-to-image": "static-1.49",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40609",
  "reporting-insights-lib": "static-1.1106",
  "reporting-plugins": "static-1.9953",
  "ui-addon-draggable-compat": "static-2.4031",
  "ui-addon-opt": "static-4.8163",
  "ui-shepherd-react": "static-3.9922",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24672",
  "hubspot-apollo-client": "static-1.4657",
  "sales-templates-service-types-lib": "static-1.3974",
  "ui-business-units-lib": "static-1.8803",
  "merchandise-lib": "static-1.258",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5451",
  "salesImages": "static-1.520",
  "ts-schema": "static-1.3884",
  "upgrade-management-service-types": "static-1.4285",
  "timezone-utils": "static-2.5022",
  "bender-build-tools": "static-1.2921",
  "chatspot-core": "static-1.20225",
  "chirp-fetch": "static-1.1662",
  "bend-plugin-foundations-theming": "static-1.2670",
  "stylex": "static-1.27",
  "hubspotter-http-shared-msw-handlers": "static-1.9427",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3604",
  "crm-pipelines-api-client-types": "static-1.3944",
  "multi-currency-client-types": "static-1.3498",
  "getting-started-shared-tasks": "static-1.17827",
  "growth-data-modal": "static-1.5129",
  "growth-onboarding-confetti": "static-1.2848",
  "growth-onboarding-next-action-utils": "static-1.1273",
  "navigation-components": "static-1.17205",
  "onboarding-tours-client": "static-1.4439",
  "onboarding-tours-utils": "static-1.291",
  "ui-shepherd-tracker": "static-1.7303",
  "ui-universal-auth": "static-1.8659",
  "user-context": "static-1.4872",
  "cms-field-types": "static-1.4583",
  "content-icons-ui": "static-1.2146",
  "integrations-lib": "static-1.15354",
  "calling-global-api": "static-1.63586",
  "calling-internal-common": "static-1.31071",
  "calling-lifecycle-internal": "static-1.64968",
  "calling-lifecycle-messages": "static-1.57262",
  "commerce-products-lib": "static-1.8800",
  "crm-links": "static-1.6034",
  "file-manager-components": "static-1.22826",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.452",
  "inbounddb-objects-service-types": "static-1.4030",
  "meetings-icalendar-utils-lib": "static-1.411",
  "object-builder-ui-client": "static-1.47900",
  "pipeline-validation-client-types": "static-1.3766",
  "property-value-citations": "static-1.1357",
  "pulse": "static-1.284",
  "smart-property-lib": "static-1.5802",
  "tiered-pricing": "static-1.794",
  "ui-addon-iframeable": "static-1.8819",
  "final-form": "static-1.65",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19433",
  "tinymce-themes": "static-1.55659",
  "data-token-picker": "static-1.16005",
  "hub-http-contrib": "static-1.2822",
  "interframe": "static-3.4569",
  "tinymce-data": "static-1.39774",
  "tinymce-plugins": "static-1.56803",
  "ui-addon-sales-email": "static-1.4991",
  "magpie-lib": "static-1.5372",
  "magpie-types": "static-1.4832",
  "simple-logging-lib": "static-1.2828",
  "content-assistance-lib": "static-1.7416",
  "dashboard-lib": "static-1.80548",
  "ExportDialog": "static-6.10166",
  "hubspot-prosemirror": "static-1.17554",
  "hubspot-prosemirror-plugins": "static-1.17546",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8469",
  "campaign-roi-lib": "static-1.8214",
  "feedback-loader": "static-1.28813",
  "onboarding-scopes": "static-1.6241",
  "apollo-link-hub-http": "static-2.4426",
  "hubspot-apollo-cache": "static-1.116",
  "growth-monetization-service-types": "static-1.4301",
  "nav-client-types": "static-1.2134",
  "purchase-motions-api": "static-1.5454",
  "trials-service-types": "static-1.3702",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.504",
  "unified-auth-core-lib": "static-1.454",
  "getting-started-shared-tasks-store": "static-1.16945",
  "integrations-error-boundary-lib": "static-1.12769",
  "integrations-tracking-lib": "static-1.5363",
  "native-integrations-shared-strings": "static-1.7566",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10150",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31077",
  "shared-worker-versioning": "static-1.10814",
  "calling-usage-tracker": "static-1.6316",
  "voice-sms-access-library": "static-1.188",
  "customer-data-tracking": "static-1.6659",
  "products-iframe-lib": "static-1.7259",
  "products-ui-components-shared-msw-handlers": "static-1.9811",
  "location-customization-utils-lib": "static-1.8499",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3932",
  "video-components-external": "static-1.10503",
  "video-data-lib": "static-1.34161",
  "directed-graph": "static-1.715",
  "event-emitter": "static-1.725",
  "breeze-intelligence-kit": "static-1.5288",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9512",
  "fsm": "static-1.3509",
  "policy-lib": "static-1.6559",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9575",
  "navigation-messaging": "static-1.6532",
  "FileManagerLib": "static-1.38466",
  "NamespacedHubStyle": "static-2.8876",
  "FileManagerCore": "static-1.38325",
  "codemirror": "static-5.90",
  "layout-dnd-components": "static-1.11990",
  "layout-dnd-utils": "static-1.10965",
  "react-codemirror": "static-1.10404",
  "ui-addon-emoji-picker": "static-1.9666",
  "ui-brand-identity-lib": "static-1.13758",
  "ui-addon-video-player": "static-1.8474",
  "ui-coaching-tips": "static-1.27890",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8347",
  "payment-link-components": "static-1.22888",
  "EmailSignatureEditor": "static-1.23862",
  "eligibility-engine-service-types": "static-1.2983",
  "universal-page-editor-lib": "static-1.2775",
  "calling-orchestration-schema": "static-1.34965",
  "sales-views-client-types": "static-1.4070",
  "crm-record-cards-service-types": "static-1.3432",
  "content-media-composition-data-lib": "static-1.11367",
  "content-media-compositions": "static-2.15374",
  "media-bridge-lib": "static-1.18527",
  "trellis-story-utils": "static-1.4301",
  "storybook-react": "static-1.28",
  "audio-components": "static-1.5580",
  "FileManagerImages": "static-1.35977",
  "video-components": "static-1.12506",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4312",
  "video-embed": "static-1.34995",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67637",
  "layout-data-lib": "static-1.9290",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6363",
  "commerce-tours-lib": "static-1.5683",
  "growth-onboarding-reliability": "static-1.4866",
  "sales-checkout-service-client": "static-1.3456",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21271",
  "sales-email-signature-service-client": "static-1.3623",
  "hls.js": "static-1.34",
  "social-insights-client-types": "static-1.21265",
  "outpost": "static-1.3982",
  "advanced-menus-core": "static-1.14782",
  "advanced-menus-lib": "static-1.11762",
  "ui-memberships-settings-lib": "static-1.33373",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14781",
  "simple-menus-lib": "static-1.16298"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33919",
  "client-types": "/client-types/static-1.444",
  "documents-lib": "/documents-lib/static-1.33924",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1903",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.99",
  "hs-promise-utils": "/hs-promise-utils/static-1.5369",
  "hs-test-utils": "/hs-test-utils/static-1.7783",
  "hub-http": "/hub-http/static-1.5966",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "HubStyleTokens": "/HubStyleTokens/static-2.11201",
  "I18n": "/I18n/static-7.1562",
  "jasmine-immutable": "/jasmine-immutable/static-1.2796",
  "jasmine-runner": "/jasmine-runner/static-1.6250",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6694",
  "react": "/react/static-7.177",
  "react-dlb": "/react-dlb/static-1.71",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16419",
  "reporting-data": "/reporting-data/static-1.66430",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8363",
  "reporting-visualizations": "/reporting-visualizations/static-1.58506",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4543",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4848",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2263",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.725",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38822",
  "customer-data-objects": "/customer-data-objects/static-1.7422",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7849",
  "data-fetching-client": "/data-fetching-client/static-1.9456",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4307",
  "flux-actions": "/flux-actions/static-1.304",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85244",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4508",
  "foundations-components": "/foundations-components/static-1.7483",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyle": "/HubStyle/static-2.11509",
  "icons": "/icons/static-2.618",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6940",
  "metrics-js": "/metrics-js/static-1.9391",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3637",
  "property-translator": "/property-translator/static-1.5191",
  "quartz-config": "/quartz-config/static-1.472",
  "quartz-core": "/quartz-core/static-1.5913",
  "quick-fetch": "/quick-fetch/static-1.3713",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5153",
  "react-virtualized": "/react-virtualized/static-2.94",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7938",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7868",
  "report-customization-components": "/report-customization-components/static-1.12447",
  "reporting-enablement": "/reporting-enablement/static-1.22007",
  "reporting-reports": "/reporting-reports/static-1.66108",
  "reporting-snowflake": "/reporting-snowflake/static-1.55048",
  "reporting-ui-components": "/reporting-ui-components/static-2.63701",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4410",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8713",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8867",
  "sanitize": "/sanitize/static-1.4252",
  "sanitize-text": "/sanitize-text/static-1.7918",
  "self-service-api": "/self-service-api/static-1.10014",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1532",
  "signup-constants": "/signup-constants/static-1.18342",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20352",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7843",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "superstore": "/superstore/static-1.4549",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10772",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10910",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9326",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17618",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10678",
  "ui-images": "/ui-images/static-2.1085",
  "UIComponents": "/UIComponents/static-3.8148",
  "usage-tracker": "/usage-tracker/static-1.7110",
  "usage-tracker-container": "/usage-tracker-container/static-1.7100",
  "usage-tracker-core": "/usage-tracker-core/static-1.6960",
  "usage-tracker-public": "/usage-tracker-public/static-1.6921",
  "viral-links-lib": "/viral-links-lib/static-1.6808",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3208",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2971",
  "quartz-webpack": "/quartz-webpack/static-1.2918",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8294",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4611",
  "foundations-theming": "/foundations-theming/static-1.4187",
  "quartz-auth": "/quartz-auth/static-1.369",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4796",
  "foundations-theming-base": "/foundations-theming-base/static-1.3172",
  "HeadJS": "/HeadJS/static-2.704",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2894",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4107",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7702",
  "graphql": "/graphql/static-1.77",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3485",
  "reporting-client-types": "/reporting-client-types/static-1.2382",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.508",
  "hs-story-utils": "/hs-story-utils/static-1.9206",
  "react-flip-move": "/react-flip-move/static-1.65",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9429",
  "hubspotter-http": "/hubspotter-http/static-1.4457",
  "sassPrefix": "/sassPrefix/static-1.151",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7027",
  "crm-message-bus": "/crm-message-bus/static-1.42295",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21256",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12782",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12919",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9601",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6553",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6648",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3655",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.748",
  "onboarding-tours": "/onboarding-tours/static-1.16225",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12980",
  "ui-addon-teams": "/ui-addon-teams/static-1.21209",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67562",
  "customer-data-properties": "/customer-data-properties/static-1.50743",
  "forms-ai-lib": "/forms-ai-lib/static-1.3979",
  "forms-utils-lib": "/forms-utils-lib/static-1.12127",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4966",
  "react-dnd-compat": "/react-dnd-compat/static-1.4400",
  "react-tinymce": "/react-tinymce/static-1.54563",
  "tinymce-config": "/tinymce-config/static-2.53689",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10125",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3752",
  "floating-ui": "/floating-ui/static-1.51",
  "react-aria": "/react-aria/static-1.61",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1127",
  "ui-fonts": "/ui-fonts/static-1.463",
  "dispatcher": "/dispatcher/static-1.131",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.787",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.477",
  "module-federation": "/module-federation/static-1.18",
  "quartz-head": "/quartz-head/static-1.359",
  "quartz-i18n": "/quartz-i18n/static-1.369",
  "quartz-routing": "/quartz-routing/static-1.124",
  "quartz-test": "/quartz-test/static-1.369",
  "batch-promise": "/batch-promise/static-1.1328",
  "external-options-client-types": "/external-options-client-types/static-1.3964",
  "react-colorpicker": "/react-colorpicker/static-2.9989",
  "copilot-toolkit": "/copilot-toolkit/static-1.10468",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12271",
  "html-to-image": "/html-to-image/static-1.49",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40609",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1106",
  "reporting-plugins": "/reporting-plugins/static-1.9953",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4031",
  "ui-addon-opt": "/ui-addon-opt/static-4.8163",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9922",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24672",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4657",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3974",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8803",
  "merchandise-lib": "/merchandise-lib/static-1.258",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5451",
  "salesImages": "/salesImages/static-1.520",
  "ts-schema": "/ts-schema/static-1.3884",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4285",
  "timezone-utils": "/timezone-utils/static-2.5022",
  "bender-build-tools": "/bender-build-tools/static-1.2921",
  "chatspot-core": "/chatspot-core/static-1.20225",
  "chirp-fetch": "/chirp-fetch/static-1.1662",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2670",
  "stylex": "/stylex/static-1.27",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9427",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3604",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3944",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3498",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17827",
  "growth-data-modal": "/growth-data-modal/static-1.5129",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2848",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1273",
  "navigation-components": "/navigation-components/static-1.17205",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4439",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.291",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7303",
  "ui-universal-auth": "/ui-universal-auth/static-1.8659",
  "user-context": "/user-context/static-1.4872",
  "cms-field-types": "/cms-field-types/static-1.4583",
  "content-icons-ui": "/content-icons-ui/static-1.2146",
  "integrations-lib": "/integrations-lib/static-1.15354",
  "calling-global-api": "/calling-global-api/static-1.63586",
  "calling-internal-common": "/calling-internal-common/static-1.31071",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64968",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57262",
  "commerce-products-lib": "/commerce-products-lib/static-1.8800",
  "crm-links": "/crm-links/static-1.6034",
  "file-manager-components": "/file-manager-components/static-1.22826",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.452",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4030",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.411",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47900",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3766",
  "property-value-citations": "/property-value-citations/static-1.1357",
  "pulse": "/pulse/static-1.284",
  "smart-property-lib": "/smart-property-lib/static-1.5802",
  "tiered-pricing": "/tiered-pricing/static-1.794",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8819",
  "final-form": "/final-form/static-1.65",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19433",
  "tinymce-themes": "/tinymce-themes/static-1.55659",
  "data-token-picker": "/data-token-picker/static-1.16005",
  "hub-http-contrib": "/hub-http-contrib/static-1.2822",
  "interframe": "/interframe/static-3.4569",
  "tinymce-data": "/tinymce-data/static-1.39774",
  "tinymce-plugins": "/tinymce-plugins/static-1.56803",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4991",
  "magpie-lib": "/magpie-lib/static-1.5372",
  "magpie-types": "/magpie-types/static-1.4832",
  "simple-logging-lib": "/simple-logging-lib/static-1.2828",
  "content-assistance-lib": "/content-assistance-lib/static-1.7416",
  "dashboard-lib": "/dashboard-lib/static-1.80548",
  "ExportDialog": "/ExportDialog/static-6.10166",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17554",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17546",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8469",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8214",
  "feedback-loader": "/feedback-loader/static-1.28813",
  "onboarding-scopes": "/onboarding-scopes/static-1.6241",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4426",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.116",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4301",
  "nav-client-types": "/nav-client-types/static-1.2134",
  "purchase-motions-api": "/purchase-motions-api/static-1.5454",
  "trials-service-types": "/trials-service-types/static-1.3702",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.504",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.454",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16945",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12769",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5363",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7566",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10150",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31077",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10814",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6316",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.188",
  "customer-data-tracking": "/customer-data-tracking/static-1.6659",
  "products-iframe-lib": "/products-iframe-lib/static-1.7259",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9811",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8499",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3932",
  "video-components-external": "/video-components-external/static-1.10503",
  "video-data-lib": "/video-data-lib/static-1.34161",
  "directed-graph": "/directed-graph/static-1.715",
  "event-emitter": "/event-emitter/static-1.725",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5288",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9512",
  "fsm": "/fsm/static-1.3509",
  "policy-lib": "/policy-lib/static-1.6559",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9575",
  "navigation-messaging": "/navigation-messaging/static-1.6532",
  "FileManagerLib": "/FileManagerLib/static-1.38466",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8876",
  "FileManagerCore": "/FileManagerCore/static-1.38325",
  "codemirror": "/codemirror/static-5.90",
  "layout-dnd-components": "/layout-dnd-components/static-1.11990",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10965",
  "react-codemirror": "/react-codemirror/static-1.10404",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9666",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13758",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8474",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27890",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8347",
  "payment-link-components": "/payment-link-components/static-1.22888",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23862",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2983",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2775",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34965",
  "sales-views-client-types": "/sales-views-client-types/static-1.4070",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3432",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11367",
  "content-media-compositions": "/content-media-compositions/static-2.15374",
  "media-bridge-lib": "/media-bridge-lib/static-1.18527",
  "trellis-story-utils": "/trellis-story-utils/static-1.4301",
  "storybook-react": "/storybook-react/static-1.28",
  "audio-components": "/audio-components/static-1.5580",
  "FileManagerImages": "/FileManagerImages/static-1.35977",
  "video-components": "/video-components/static-1.12506",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4312",
  "video-embed": "/video-embed/static-1.34995",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67637",
  "layout-data-lib": "/layout-data-lib/static-1.9290",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6363",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5683",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4866",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3456",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21271",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3623",
  "hls.js": "/hls.js/static-1.34",
  "social-insights-client-types": "/social-insights-client-types/static-1.21265",
  "outpost": "/outpost/static-1.3982",
  "advanced-menus-core": "/advanced-menus-core/static-1.14782",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11762",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33373",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14781",
  "simple-menus-lib": "/simple-menus-lib/static-1.16298"
}
};
